import React from 'react';
import { useRecoilState } from 'recoil';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

interface IProps {
  primaryDatasheetUrl: any;
}
export const DatasheetIcon: React.FC<IProps> = (props: any) => {
  const [utagData] = useRecoilState(utagObjectAtom);
  return (
    <div style={{ margin: 'auto' }}>
      <a
        className="data-sheet-icon"
        href={props.primaryDatasheetUrl}
        target="_blank"
        rel="noreferrer"
        onClick={()=>callGTMAnalytics(utagData, "Display Asset")}
        track-data="ref_page_event=Display Asset; asset_type=Datasheet"
      >
        <span className="icon-file-pdf"></span>
      </a>
    </div>
  );
};
